
import Api from './api'

export default {

    getAll: function () {

        return Api.get('/partners')
            .catch(() => { redirectMainPage() })

    }
}

function redirectMainPage () {

    window.location.href = '/'

}
